import { useMobileModal } from '../screens/profile/mobile-modal';

function useMobileWorkflow() {
  const { prepareMobileModal, showMobileModal } = useMobileModal();

  async function prepare() {
    await prepareMobileModal();
  }

  async function show({
    showBackButton,
    prepareOnPreConfirm,
    prepareOnPreDeny,
  }) {
    const result = await showMobileModal({
      showBackButton,
      prepareOnPreConfirm,
      prepareOnPreDeny,
    });
    return result;
  }

  return {
    prepareMobileWorkflow: prepare,
    showMobileWorkflow: show,
  };
}

export { useMobileWorkflow };
